<script lang="ts">
  export let together = false;
  export let onClick: (together: boolean) => void = () => {};

  function toggleActive() {
    together = !together;
    onClick(together);
  }
</script>

<section class="together" class:active={together}>
  <button on:click={toggleActive} class="sf-500"> Seated Together</button>
</section>

<style lang="scss">
  @use "@styles/breakpoint-mixins" as *;
  .together {
    margin: 0;
    border: 1px solid #d8d8d8;
    border-radius: 10px;
    button {
      padding: 0.55em;
      border: none;
      background: none;
      color: #171717;
      font-size: 0.9em;
      font-weight: 500;
      line-height: 20px;
      @include desktop {
        font-size: 18px;
      }
    }
    &.active {
      background: rgb(123, 201, 237, 0.3);
    }
  }
</style>
